type TINEntry = {example: string; type: string};

type TINExamplesByLegalPersonType = {
    SOLETRADER?: TINEntry;
    BUSINESS?: TINEntry;
    ORGANIZATION?: TINEntry;
    PARTNERSHIP?: TINEntry;
    default?: TINEntry;
};

export const TIN_EXAMPLES_BY_COUNTRY: Record<string, TINExamplesByLegalPersonType> = {
    AT: {
        SOLETRADER: {example: '12-345/6789', type: 'Steuer Nr.'},
        BUSINESS: {example: '12-345/6789', type: 'Steuernummer'},
        ORGANIZATION: {example: '12-345/6789', type: 'Steuernummer'},
    },
    BE: {
        SOLETRADER: {example: '12345678901', type: 'Numéro National'},
        BUSINESS: {example: '12345678901', type: "Numéro d'entreprise"},
        ORGANIZATION: {example: '12345678901', type: "Numéro d'entreprise"},
    },
    BG: {
        SOLETRADER: {example: '1234567890', type: 'ЕГН'},
        BUSINESS: {example: '1234567890', type: 'UIC'},
        ORGANIZATION: {example: '1234567890', type: 'UIC'},
    },
    CA: {
        default: {example: '123-456-789', type: 'SIN / BN'},
    },
    CY: {
        default: {example: '12345678A', type: 'Tax Identification Code'},
    },
    CZ: {
        SOLETRADER: {example: '123456/1234', type: 'Rodné číslo'},
        BUSINESS: {example: '123456/1234', type: 'IČO'},
        ORGANIZATION: {example: '123456/1234', type: 'IČO'},
    },
    DE: {
        SOLETRADER: {example: '12345678901', type: 'Identifikationsnummer'},
        BUSINESS: {example: '12345678901', type: 'Steuernummer'},
        ORGANIZATION: {example: '12345678901', type: 'Steuernummer'},
    },
    DK: {
        SOLETRADER: {example: '123456-7890', type: 'CPR'},
        BUSINESS: {example: '123456-7890', type: 'CVR'},
        ORGANIZATION: {example: '123456-7890', type: 'CVR'},
    },
    EE: {
        SOLETRADER: {example: '12345678901', type: 'Isikukood'},
        BUSINESS: {example: '12345678901', type: 'Registrikood'},
        ORGANIZATION: {example: '12345678901', type: 'Registrikood'},
    },
    ES: {
        SOLETRADER: {example: '01234567A', type: 'DNI / NIE'},
        BUSINESS: {example: 'X1234567A', type: 'NIF'},
        ORGANIZATION: {example: 'X1234567A', type: 'NIF'},
    },
    FI: {
        SOLETRADER: {example: '123456-789A', type: 'henkilötunnus'},
        BUSINESS: {example: '123456-789A', type: 'henkilötunnus'},
        ORGANIZATION: {example: '123456-789A', type: 'henkilötunnus'},
    },
    FR: {
        SOLETRADER: {example: '0123456789123', type: "Numéro d'identification fiscale"},
        BUSINESS: {example: '0123456789123', type: "Numéro d'identification fiscale"},
        ORGANIZATION: {example: '0123456789123', type: "Numéro d'identification fiscale"},
    },
    GB: {
        SOLETRADER: {example: 'AB123456A', type: 'NINO'},
        BUSINESS: {example: 'AB123456A', type: 'NINO'},
        ORGANIZATION: {example: 'AB123456A', type: 'NINO'},
    },
    GR: {
        default: {example: '123456789', type: 'AFM'},
    },
    HR: {
        default: {example: '12345678901', type: 'OIB'},
    },
    HU: {
        SOLETRADER: {example: '8123456789', type: 'Adóazonosító jel'},
        BUSINESS: {example: '12345678-1-12', type: 'Adószám'},
        ORGANIZATION: {example: '12345678-1-12', type: 'Adószám'},
    },
    IE: {
        SOLETRADER: {example: '1234567A', type: 'PPS No'},
        BUSINESS: {example: '1234567A', type: 'Tax Reference Number'},
        ORGANIZATION: {example: '1234567A', type: 'Tax Reference Number'},
    },
    IT: {
        SOLETRADER: {example: 'RSSMRA85M01H501Z', type: 'Codice fiscale'},
        BUSINESS: {example: '01234567891', type: 'Codice fiscale'},
        ORGANIZATION: {example: '01234567891', type: 'Codice fiscale'},
    },
    LT: {
        SOLETRADER: {example: '12345678901', type: 'Asmens kodas'},
        BUSINESS: {example: '12345678901', type: 'JAR kodas'},
        ORGANIZATION: {example: '12345678901', type: 'JAR kodas'},
    },
    LU: {
        SOLETRADER: {example: '1234567890123', type: 'Numéro national'},
        BUSINESS: {example: '1234567890123', type: 'Numéro national'},
        ORGANIZATION: {example: '1234567890123', type: 'Numéro national'},
    },
    LV: {
        SOLETRADER: {example: '12345678901', type: 'Personas kods'},
        BUSINESS: {example: '40001234567', type: 'Reģistrācijas numurs'},
        ORGANIZATION: {example: '40001234567', type: 'Reģistrācijas numurs'},
    },
    MT: {
        SOLETRADER: {example: '1234567M', type: 'ID Card Number'},
        BUSINESS: {example: '110000001', type: 'Unique Taxpayer Reference Number'},
        ORGANIZATION: {example: '110000001', type: 'Unique Taxpayer Reference Number'},
    },
    NL: {
        SOLETRADER: {example: '123456789', type: 'Persoonsnummer'},
        BUSINESS: {example: '123456789', type: 'RSIN'},
        ORGANIZATION: {example: '123456789', type: 'RSIN'},
    },
    PL: {
        SOLETRADER: {example: '12345678901', type: 'PESEL'},
        BUSINESS: {example: '1234567890', type: 'NIP'},
        ORGANIZATION: {example: '1234567890', type: 'NIP'},
    },
    PT: {
        SOLETRADER: {example: '123456789', type: 'NIF'},
        BUSINESS: {example: '512345678', type: 'NIPC'},
        ORGANIZATION: {example: '512345678', type: 'NIPC'},
    },
    RO: {
        SOLETRADER: {example: '1234567890123', type: 'CNP'},
        BUSINESS: {example: '12345678', type: 'CUI / CIF'},
        ORGANIZATION: {example: '12345678', type: 'CUI / CIF'},
    },
    SE: {
        SOLETRADER: {example: '123456-7890', type: 'Personnummer'},
        BUSINESS: {example: '123456-7890', type: 'Organisationsnummer'},
        ORGANIZATION: {example: '123456-7890', type: 'Organisationsnummer'},
    },
    SI: {
        default: {example: '12345678', type: 'Davčna številka'},
    },
    SK: {
        SOLETRADER: {example: '123456/1234', type: 'Rodné číslo'},
        BUSINESS: {example: '123456/1234', type: 'DIČ'},
        ORGANIZATION: {example: '123456/1234', type: 'DIČ'},
    },
};

const FRENCH_OVERSEAS_TIN_ENTRY = TIN_EXAMPLES_BY_COUNTRY['FR']!;

// French overseas territories share the same TIN format as metropolitan France
TIN_EXAMPLES_BY_COUNTRY['GP'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['MQ'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['GF'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['RE'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['YT'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['PM'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['BL'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['MF'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['WF'] = FRENCH_OVERSEAS_TIN_ENTRY;
TIN_EXAMPLES_BY_COUNTRY['TF'] = FRENCH_OVERSEAS_TIN_ENTRY;
